import { Box, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <Box sx={{ textAlign: 'center', py: 8 }}>
      <Typography variant="h4" gutterBottom>Page not found</Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        The page you&apos;re looking for doesn&apos;t exist.
      </Typography>
      <Button component={Link} to="/products" variant="contained">
        Go to Products
      </Button>
    </Box>
  );
}
